<template>
  <v-chip
    v-if="voteRank && voteRank != 'N/A'"
    :color="voteRankColor"
    label
    class="mr-3"
    style="text-transform: capitalize; height: 36px; font-weight: 400"
  >
    Vote Rank: {{ voteRank }}
  </v-chip>
</template>

<script>
import { formatMetricValue } from '../../services/metricService';

export default {
  props: {
    blockProducer: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    voteRank() {
      let alert = this.blockProducer.alerts.filter(
        (alert) => alert.metric == `Producer/Rank`
      )[0];

      if (!alert) {
        return 'N/A';
      }

      let value = this.$store.state.metrics.metric[alert.id];
      if (!value) {
        return 'N/A';
      }
      return formatMetricValue('Producer', 'Rank', value);
    },
    voteRankColor() {
      if (this.voteRank <= 21) return '#daa520';
      else if (this.voteRank <= 40) return '#c0c0c0';
      else return '#CD7F32';
    },
  },
};
</script>
